import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Card from '../../components/Card/Card';
import Footer from '../../components/Footer/Footer';

const NotFoundPage = (props) => {

  return (
    <Fragment>

      <Helmet>
        <title>{props.appState.ui.notFound.meta.title}</title>
        <meta name="description" content={props.appState.ui.notFound.meta.description} />
      </Helmet>

      <Header header={props.appState.ui.header} url={props.url}/>
      <Main site={props.appState.ui.site} >
        <Card card={props.appState.ui.notFound.card} />
      </Main>
      <Footer footer={props.appState.ui.footer} url={props.url} clientTerms={props.appState.ui.clientTerms} />
      
    </Fragment>
  );
};

export default NotFoundPage;


// WEBPACK FOOTER //
// ./src/containers/NotFoundPage/NotFoundPage.js